function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationFlagGarlandSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA921"
    },
    d: "M346.725,207.381l20.076,130.409l50.693-52.405l66.718,34.33l-20.724-134.614 C430.294,195.173,390.587,202.871,346.725,207.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58200"
    },
    d: "M454.553,304.454l29.659,15.261l-20.724-134.614c-8.339,2.53-17.089,4.91-26.213,7.127 L454.553,304.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB0125"
    },
    d: "M255.903,211.925c-20.319,0-40.171-0.668-59.398-1.922v131.733l22.039-16.729l1.077-0.817 l23.585-17.902l11.376-8.635l60.717,44.082V210.003C296.074,211.257,276.223,211.925,255.903,211.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC111E"
    },
    d: "M288.352,211.338V322.17l26.948,19.565V210.003C306.449,210.58,297.453,211.017,288.352,211.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA921"
    },
    d: "M48.318,185.101L27.594,319.715l66.718-34.33l50.693,52.405l20.076-130.409 C121.219,202.871,81.512,195.173,48.318,185.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58200"
    },
    d: "M138.71,204.212L121.713,313.71l23.293,24.08l20.076-130.409 C156.107,206.458,147.317,205.395,138.71,204.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A1A1A"
    },
    d: "M511.272,166.858c-1.882-4.218-6.831-6.11-11.041-4.228C442.968,188.176,351.666,203.427,256,203.427 c-95.667,0-186.969-15.251-244.232-40.797c-4.215-1.882-9.159,0.011-11.041,4.228s0.013,9.159,4.229,11.041 c10.436,4.655,21.831,8.958,34.028,12.903l-19.653,127.64c-0.478,3.107,0.827,6.219,3.377,8.056c2.549,1.836,5.913,2.09,8.71,0.65 l61.199-31.491l46.378,47.945c1.601,1.654,3.78,2.548,6.01,2.548c0.847,0,1.701-0.128,2.533-0.393 c3.026-0.963,5.246-3.556,5.729-6.695l18.89-122.708c5.282,0.489,10.613,0.93,15.986,1.325v124.055c0,3.176,1.798,6.076,4.643,7.488 c1.178,0.584,2.45,0.872,3.716,0.872c1.792,0,3.574-0.576,5.055-1.701l53.134-40.33l55.695,40.436 c2.543,1.846,5.908,2.111,8.709,0.683c2.8-1.428,4.563-4.305,4.563-7.448V217.694c5.374-0.395,10.705-0.834,15.988-1.322 l18.888,122.69c0.484,3.138,2.703,5.732,5.729,6.695c0.833,0.265,1.686,0.393,2.533,0.393c2.23,0,4.41-0.894,6.01-2.548 l46.378-47.945l61.199,31.491c1.206,0.621,2.518,0.926,3.824,0.926c0.008,0,0.014,0,0.022,0h0.001c4.618,0,8.36-3.743,8.36-8.36 c0-0.651-0.074-1.284-0.214-1.893l-19.546-126.96c12.265-3.963,23.721-8.284,34.208-12.963 C511.258,176.018,513.152,171.075,511.272,166.858z M139.306,319.873l-38.985-40.301c-1.614-1.67-3.798-2.548-6.011-2.548 c-1.3,0-2.611,0.302-3.823,0.926l-52.134,26.827L55.129,195.8c29.945,8.42,63.62,14.779,100.36,18.952L139.306,319.873z  M421.319,277.95c-3.276-1.687-7.271-1.03-9.834,1.622L372.5,319.873l-16.184-105.12c36.74-4.172,70.415-10.533,100.36-18.952 l16.777,108.977L421.319,277.95z M306.941,325.335l-47.446-34.447c-1.466-1.064-3.189-1.595-4.911-1.595 c-1.781,0-3.561,0.568-5.054,1.701l-44.663,33.901V218.88c33.747,1.865,68.327,1.865,102.074,0V325.335z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationFlagGarlandSvgrepoCom);
export default __webpack_public_path__ + "static/media/celebration-flag-garland-svgrepo-com.e55fc03279098c84d13091383ac41843.svg";
export { ForwardRef as ReactComponent };